
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 438.858 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M182.858 438.857a18.286 18.286 0 00-18.286-18.286H18.287a18.286 18.286 0 000 36.572h146.285a18.286 18.286 0 0018.286-18.286zM91.43 146.286a73.143 73.143 0 10-73.143-73.143 73.143 73.143 0 0073.143 73.143zm0-109.715a36.571 36.571 0 11-36.572 36.572A36.571 36.571 0 0191.43 36.57z"}}),_c('path',{attrs:{"d":"M219.43 512h54.857a18.286 18.286 0 0018.285-18.286v-128a54.857 54.857 0 00-54.857-54.857h-54.857V259.11a93.806 93.806 0 00-82.468-94.538A91.429 91.429 0 000 256v128a18.286 18.286 0 0018.286 18.286h182.857v91.428A18.286 18.286 0 00219.43 512zM36.572 365.714V256a54.857 54.857 0 0160.343-54.857 57.051 57.051 0 0149.372 57.966v70.034a18.286 18.286 0 0018.285 18.286h73.143a18.286 18.286 0 0118.286 18.285V475.43h-18.286V384a18.286 18.286 0 00-18.285-18.286zm256-310.857a18.286 18.286 0 00-36.57 0v109.714a18.286 18.286 0 0036.57 0zm109.715 0v109.714a18.286 18.286 0 0036.571 0V54.857a18.286 18.286 0 00-36.571 0zm-73.143-36.571v182.857a18.286 18.286 0 0036.571 0V18.286a18.286 18.286 0 00-36.571 0z"}})])])
          )
        }
      }
    